import { GridFilterItem, GridFilterModel } from '@mui/x-data-grid-pro'

const allowedOperators = ['contains', 'is', 'not', '!=', '>', '<', '=', 'after', 'before', 'onOrAfter', 'onOrBefore'] as const
export type GridFilterOperators = typeof allowedOperators[number]
type ListFilterOperators = 'ILIKE' | '=' | '!=' | '>' | '<' | '>=' | '<='

interface ValidGridFilterItem {
  operator: GridFilterOperators
  value: string
  field: string
}

function isValidGridFilterItem(input: GridFilterItem): input is ValidGridFilterItem {
  return (
    typeof input.value === 'string' &&
    input.value.length > 0 &&
    allowedOperators.some(allowedOperator => allowedOperator === input.operator)
  )
}

interface ListSearchItem {
  operator: ListFilterOperators
  value: string
  field: string
}

const exactMatchFields = ['Order.WorkOrderUUID']

function isUUIDField(field: string): boolean {
  return field.endsWith('UUID')
}

function createListSearchItem(input: ValidGridFilterItem): ListSearchItem {
  if (exactMatchFields.includes(input.field) || isUUIDField(input.field)) {
    return {
      operator: '=',
      value: input.value,
      field: input.field
    }
  }

  switch (input.operator) {
    case 'contains': {
      return {
        operator: 'ILIKE',
        value: `%${input.value}%`,
        field: input.field
      }
    }
    case '=':
    case 'is': {
      return {
        operator: '=',
        value: input.value,
        field: input.field
      }
    }
    case '!=':
    case 'not': {
      return {
        operator: '!=',
        value: input.value,
        field: input.field
      }
    }
    case 'after':
    case '>': {
      return {
        operator: '>',
        value: input.value,
        field: input.field
      }
    }
    case 'before':
    case '<': {
      return {
        operator: '<',
        value: input.value,
        field: input.field
      }
    }
    case 'onOrAfter': {
      return {
        operator: '>=',
        value: input.value,
        field: input.field
      }
    }
    case 'onOrBefore': {
      return {
        operator: '<=',
        value: input.value,
        field: input.field
      }
    }
  }
}

function mapGridFilterItemsToListSearchItems(input: GridFilterItem[], isSupplierOrderEnabled = false): ListSearchItem[] {
  return input
    .filter(isValidGridFilterItem)
    .filter(item => isSupplierOrderEnabled || (item.field !== 'OrderLine.OrderStatus' && item.field !== 'SupplierOrderLine.OrderStatus'))
    .map(createListSearchItem)
}

function mapListSearchItemToSearchString(input: ListSearchItem): string {
  return `${input.field}|${input.operator}|${input.value}`
}

export function mapGridFilterModelToListSearch(filterModel: GridFilterModel, isSupplierOrderEnabled = false) {
  const searchItems = mapGridFilterItemsToListSearchItems(filterModel.items, isSupplierOrderEnabled)

  return searchItems.map(mapListSearchItemToSearchString).join(',')
}
